import { OrderShort } from '@solidgate/react-sdk';

import { AnalyticPaymentMethods, PAYMENT_METHODS } from '~/types/payment';

export enum UpdatePaymentTokenReason {
  REDEMPTION = 'redemption',
  PREPAID = 'prepaid',
}

export type PaymentApi = {
  createPaymentIntentCard: (geo_country: string) => Promise<{
    merchant: string;
    payment_intent: string;
    signature: string;
  }>;
  createPaymentIntentPaypal?: () => Promise<{
    order: Record<string, any>;
    order_metadata: any;
    pay_form: Record<string, any>;
  }>;
};

export type PaymentFormProps = {
  onPaymentSuccess: (order: OrderShort) => void | Promise<void>;
  onPaymentFail: (message: string, method: AnalyticPaymentMethods) => void;
  onPaymentSubmit: (method: AnalyticPaymentMethods) => void;
  onPaymentMethodChange: (type: PAYMENT_METHODS) => void;
  onCreateCardIntentError?: (errorMessage: string) => void;
  onFormReady?: () => void | Promise<void>;
  paymentApi: PaymentApi;
};
